import router from '../router'
import VueTk from '@moke/vue-tk'
const rulers = []

VueTk.tkRouterAuth.init(rulers, router)
